export const state = {
  expenses: [],
  expense_item: [
    {
      expense_description: "",
      expense_measurement: "",
      qty: "",
      unit_price: "",
      total_price: "",
    }
  ]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/expenses/state.js